<app-base-modal
  [title]="factoryBankDetailsResourceType.name"
  [showStateToggle]="isValid()"
>
  <div class="factory-bank-details-wrapper">
    @if (isLoading) {
      <app-loader/>
    }
    <mat-accordion [multi]="true">
      @for (data of factoryBankDetailsData(); track data.id) {
        <mat-expansion-panel [expanded]="data.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <app-factory-bank-details-title
                [data]="data"
                [isEditModeActive]="isEditModeActive"
                (handleDelete)="handleDelete($event, data.id, $index)"
              />
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-factory-bank-details-form
            [technicalParametersId]="technicalParametersId()"
            [factoryBankDetailsData]="data"
            [factoryBankDetailsFormGroup]="factoryBankDetailsFormGroups()[$index]"
            [noFirstData]="noFirstData()"
            [isEditModeActive]="isEditModeActive"
            (updateFactoryBankDetailsData)="updateFactoryBankDetailsData($event, $index)"
            (deleteFactoryBankDetailsData)="deleteFactoryBankDetailsData($index)"
            (setLoadingState)="setLoadingState($event)"
          />
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid()"
      (click)="handleAddNew()"
    >
      Добавить новый
    </button>
  </div>
</app-base-modal>
